import './Loading.scss'


export default function () {

    return <div className="">

        <p className="lds-roller2 text-center pt-3" style={{fontFamily:'iranSanse-medium',fontSize:12}}>خورشید پیشوا</p>
        <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
}
